export default __webpack_public_path__ + "static/media/EM0830.34I-22678_-15175_0.bdd24ae0.jpg";